import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class QueuesStatsService {
  constructor(private http: HttpClient) {}

  public all(params: any) {
    let projectId;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v5/projects/${projectId}/queues-stats`;

    return this.http.get(url, { params });
  }

  public get(params: any) {
    let projectId;
    let queueId;

    [params, projectId, queueId] = splayParams(params, "projectId", "queueId");
    const url = `/api/v5/projects/${projectId}/queues/${queueId}/stats`;

    return this.http.get(url, { params });
  }
}
